(() => {
 'use strict';
  const hubLabels = JSON.parse(document.getElementById('HubDisplayLabels')?.textContent || '{}');
  const hubText = key => hubLabels[key] || key;

 const initMedia=scope=>scope.querySelectorAll('[data-g52-media]').forEach(w=>{
  if(w.dataset.ready)return;w.dataset.ready='1';
  const v=w.querySelector('video'),b=w.querySelector('[data-g52-play]');if(!v)return;
  const mobile=matchMedia('(max-width:749px)'),motion=matchMedia('(prefers-reduced-motion: reduce)');
  const scene=w.closest('[data-feature-panel], [data-g52-wear], [data-g52-pov]'),copy=scene?.querySelector('.g52-scene-copy');
  let clips=[];try{clips=JSON.parse(w.querySelector('[data-g52-sequence]')?.textContent||'[]').filter(c=>c.src)}catch{}
  let index=0,inView=false,wanted=false,failed=0;
  if(mobile.matches&&v.dataset.mobilePoster)v.poster=v.dataset.mobilePoster;
  const source=()=>mobile.matches&&v.dataset.mobileSrc?v.dataset.mobileSrc:v.dataset.src;
  const paint=()=>{if(b){b.textContent=v.paused?hubText('play_video'):hubText('pause_video');b.setAttribute('aria-label',b.textContent+'：'+v.getAttribute('aria-label'));b.setAttribute('aria-pressed',String(!v.paused))}};
  const apply=(i,animate=false)=>{
   index=i;w.dataset.sequenceIndex=String(i);const c=clips[i];if(!c)return;
   v.pause();v.dataset.src=c.src;v.poster=c.poster||v.poster;v.removeAttribute('src');v.load();v.loop=clips.length===1;
   const title=scene?.querySelector('[data-scene-title]'),subtitle=scene?.querySelector('[data-scene-subtitle]');
   if(c.title&&title)title.textContent=c.title;if(c.subtitle&&subtitle)subtitle.textContent=c.subtitle;
   v.setAttribute('aria-label',[title?.textContent,c.subtitle].filter(Boolean).join(' · '));
   if(animate&&copy&&!motion.matches){copy.getAnimations().forEach(a=>a.cancel());copy.animate([{opacity:.3,transform:'translateY(9px)'},{opacity:1,transform:'translateY(0)'}],{duration:650,easing:'cubic-bezier(.2,.7,.25,1)'})}
  };
  const start=()=>{if(!wanted||!inView||document.hidden)return;v.play().catch(paint)};
  w.g52Play=()=>{wanted=true;if(v.getAttribute('src')!==source()||v.error){v.src=source();v.load()}document.dispatchEvent(new CustomEvent('g52:media-play',{detail:v}));start()};
  w.g52Pause=()=>{wanted=false;v.pause()};
  w.g52Suspend=()=>v.pause();w.g52Resume=start;
  w.g52Reset=()=>{w.g52Pause();if(clips.length)apply(0);else if(v.readyState)v.currentTime=0};
  w.g52Toggle=()=>{if(v.paused)w.g52Play();else w.g52Pause()};
  b?.addEventListener('click',w.g52Toggle);
  ['play','pause','ended','error','loadedmetadata'].forEach(e=>v.addEventListener(e,paint));
  v.addEventListener('ended',()=>{if(!wanted||!inView||document.hidden||motion.matches||clips.length<2)return;apply((index+1)%clips.length,true);w.g52Play()});
  v.addEventListener('error',()=>{if(wanted&&inView&&clips.length>1&&failed<clips.length-1){failed++;apply((index+1)%clips.length,true);w.g52Play()}});
  v.addEventListener('playing',()=>{failed=0});
  document.addEventListener('g52:media-play',e=>{if(e.detail!==v)w.g52Pause()});
  document.addEventListener('visibilitychange',()=>{if(document.hidden)v.pause();else start()});
  new IntersectionObserver(es=>{inView=es[0].isIntersecting&&es[0].intersectionRatio>=.1;if(inView)start();else v.pause()},{threshold:[0,.1]}).observe(w);
  if(clips.length)apply(0);else v.loop=true;paint();
 });
 const init=()=>{
  initMedia(document);
  document.querySelectorAll('[data-g52-explorer]').forEach(root=>{
   if(root.dataset.ready)return;root.dataset.ready='1';
   const panels=[...root.querySelectorAll('[data-feature-panel]')];
   root.g52SelectFeature=(key,play=false)=>{
    if(!panels.some(p=>p.dataset.featurePanel===key))key='protection';
    panels.forEach(p=>{const w=p.querySelector('[data-g52-media]');w.g52Pause?.();p.hidden=p.dataset.featurePanel!==key;if(!p.hidden){w.g52Reset?.();if(play)w.g52Play?.()}});
    root.dataset.activeFeature=key;
   };
   root.g52SelectFeature(root.dataset.activeFeature||'protection');
  });
 };
 init();document.addEventListener('shopify:section:load',init);
})();
